import React, { forwardRef, ComponentProps } from 'react';

import Icon, { IconWithRender } from './Icon';

const ViewPlusIcon = forwardRef<SVGSVGElement, ComponentProps<typeof Icon>>(
  (props, ref) => (
    <Icon data-testid="viewPlus" ref={ref} {...props}>
      <path d="M13.23,20h-7a3.76,3.76,0,0,1-3.75-3.75V6A3.75,3.75,0,0,1,6.18,2.21H16.23A3.76,3.76,0,0,1,20,6v7.27a.75.75,0,0,1-1.5,0V6a2.25,2.25,0,0,0-2.25-2.25h-10A2.25,2.25,0,0,0,3.93,6V16.23a2.25,2.25,0,0,0,2.25,2.25h7.05a.75.75,0,0,1,0,1.5ZM22,18.48H20v-2a.75.75,0,0,0-1.5,0v2h-2a.75.75,0,0,0,0,1.5h2v2A.75.75,0,0,0,20,22V20h2a.75.75,0,0,0,0-1.5Z" />
    </Icon>
  ),
) as IconWithRender;

ViewPlusIcon.displayName = 'ViewPlusIcon';
ViewPlusIcon.renderIcon = (props) => <ViewPlusIcon {...props} />;
export default ViewPlusIcon;
